var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    clipPath: "url(#clip0_58609_15279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 59"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_58609_15279",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.751 30.1484C17.751 29.978 17.8891 29.8398 18.0595 29.8398H21.9422C22.1126 29.8398 22.2508 29.978 22.2508 30.1484C22.2508 31.1709 21.4219 31.9998 20.3994 31.9998H19.6024C18.5799 31.9998 17.751 31.1709 17.751 30.1484Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.751 30.1484C17.751 29.978 17.8891 29.8398 18.0595 29.8398H21.9422C22.1126 29.8398 22.2508 29.978 22.2508 30.1484C22.2508 31.1709 21.4219 31.9998 20.3994 31.9998H19.6024C18.5799 31.9998 17.751 31.1709 17.751 30.1484Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_58609_15279)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 58",
    d: "M27.9998 17.9596V27.12C27.9998 27.6722 27.5521 28.12 26.9998 28.12H13.0005C12.4482 28.12 12.0005 27.6722 12.0005 27.12V17.9596C12.0005 13.5415 15.5821 9.95996 20.0001 9.95996C24.4182 9.95996 27.9998 13.5415 27.9998 17.9596Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M26.2498 8C27.7497 8.72 29.2496 10.16 29.9996 11.6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 28",
    d: "M13.7502 8C12.2503 8.72 10.7504 10.16 10.0004 11.6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58609_15279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification3);
export default __webpack_public_path__ + "static/media/Notification3.16f13b4ffadad1a8f6be4b268b5746ab.svg";
export { ForwardRef as ReactComponent };